import FileUploader from 'components/UploaderAndDownloader/FileUploader';
import React, { useCallback, useContext } from 'react';
import { createAppError } from 'utils/helpers';
import { AppContext, IAppContext } from 'appState/appContext';
import {
	CreateApkContext,
	ICreateApkContext,
} from 'modules/FirmwareAndApp/Apk/CreateApk/createApkState/createApkContext';
import { useAdditionalValidation } from 'components/WithAdditionalValidation/useAdditionalValidation';
import { postMediaFile } from 'backend/additionalInformation';
import style from './ApkSettingsBlock.module.scss';

const ApkSettingsBlock: React.FC = () => {
	const { showLoader, hideLoader, setUploadProgress, addAppError } = useContext<IAppContext>(AppContext);
	const { changeFileData, fileData } = useContext<ICreateApkContext>(CreateApkContext);
	const { isShowValidationError, validationErrorMessage } = useAdditionalValidation(
		fileData.fileId,
		'shouldUploadApkFile',
		'apkUpload',
	);

	const sendForm = async (file: File, callback: (value: string) => void) => {
		showLoader();
		const formData = new FormData();
		formData.append('file', file, file.name);

		try {
			const { data } = await postMediaFile({
				data: formData,
				config: {
					onUploadProgress: (progressEvent) => {
						const progress =
							progressEvent.total != null
								? Math.round((progressEvent.loaded * 100) / progressEvent.total)
								: 0;
						setUploadProgress(progress);
					},
				},
			});
			changeFileData({ fileId: data.fileId, fileHash: data.fileHash, fileName: file.name });
			callback(file.name);
			hideLoader();
		} catch (err) {
			hideLoader();
			const error = err as Error;
			const appError = createAppError(error);
			addAppError(appError);
		}
	};

	const resetFile = useCallback(() => {
		changeFileData({ fileId: '', fileHash: null, fileName: null });
	}, []);

	return (
		<div className={style.container} data-test="ApkSettingsBlock">
			<FileUploader
				fileType="apk"
				onFileLoad={sendForm}
				onFileReset={resetFile}
				id="apkUpload"
				label="uploadApkLabel"
				requiredValidationMessage={isShowValidationError ? validationErrorMessage : undefined}
				filePath={fileData.fileName}
			/>
		</div>
	);
};

export default ApkSettingsBlock;
